export default __webpack_public_path__ + "static/media/logo.826f661c.png";